"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FileSchema = exports.PersistedFileSchema = void 0;
const validation_1 = require("../../validation");
const ItemDefinition_1 = require("./ItemDefinition");
const zod_1 = require("zod");
const types_1 = require("../../types");
exports.PersistedFileSchema = zod_1.z.object({
    identifier: zod_1.z.string((0, validation_1.labelZodErrors)("File Upload Completed")),
    originalBasename: zod_1.z.string((0, validation_1.labelZodErrors)("File Name")),
    extension: zod_1.z.string((0, validation_1.labelZodErrors)("File Upload Completed")),
    mime: zod_1.z.string((0, validation_1.labelZodErrors)("File Upload Completed")),
    type: zod_1.z.enum(types_1.MEDIA_ITEM_TYPES),
}, (0, validation_1.labelZodErrors)("File"));
exports.FileSchema = exports.PersistedFileSchema.extend({
    /**
     * Signed URL is added dynamically by the backend but not stored nor sent when saving.
     */
    signedUrl: zod_1.z.optional(zod_1.z.string()),
    /**
     * Signed Preview URL is added dynamically by the backend but not stored nor sent when saving.
     */
    signedPreviewUrl: zod_1.z.optional(zod_1.z.string()),
});
const configSchema = zod_1.z.object({});
const dataSchema = zod_1.z.object({
    files: zod_1.z.array(exports.FileSchema).min(1, "Must upload at least one file."),
});
exports.default = new ItemDefinition_1.ItemDefinition("FileUploadV2", configSchema, dataSchema, new validation_1.ValidatorPipeline("FileUploadV2 Config Validator", []), new validation_1.ValidatorPipeline("FileUploadV2 Data Validator", []));
//# sourceMappingURL=FileUploadV2.js.map